import React from 'react'

export default ({ size }) => (
	<svg width={size} height={size} viewBox="0 0 49 49" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="24.5" cy="24.5" r="24.5" fill="#CCB08D" />
		<circle cx="24.6574" cy="24.657" r="22.1154" fill="#DDD4C8" stroke="white" />
		<path d="M35.6091 13.4509L25.1676 15.414L14.7262 13.4509C13.3888 13.2423 12.4072 14.4876 12.4072 15.7575V30.7572C12.4072 32.0271 13.3888 32.7571 14.7262 33.0639L25.1676 35.0209L35.6091 33.0577C36.9465 32.751 37.9281 32.0209 37.9281 30.751V15.7575C37.9281 14.4876 36.9465 13.2423 35.6091 13.4509ZM35.6091 30.751L26.3333 32.7142V17.7146L35.6091 15.7514V30.751ZM24.002 32.7142L14.7262 30.751V15.7575L24.002 17.7207V32.7142Z" fill="#CCB08D" />
		<path d="M26.2303 17.8142L35.8006 15.6874V30.5746L26.2303 32.7013V17.8142Z" fill="white" />
		<path d="M24.1035 17.8142V32.7013L14.5332 30.5746V15.6874L24.1035 17.8142Z" fill="white" />
	</svg>
)